import type { AnnotationState, TooltipState } from '../types/state.js';

export const initialSelectionState = {
  hoveredGroup: undefined,
  pinnedGroup: undefined,
  hoveredItem: undefined,
  hoveredListItem: undefined,
  data: undefined,
  hoverGroupListKey: undefined,
};

const initialTooltipState: TooltipState = {
  visibility: false,
  pinned: false,
  data: undefined,
  position: undefined,
};

export const initialState: AnnotationState = {
  tooltip: initialTooltipState,
  selection: initialSelectionState,
};
